/* ===== PRODUCT DATA + VARIANT HELPERS (public_title based) ===== */

const productData = (window.meta && window.meta.product) || null

function getCurrentSelections() {
  const selections = {}

  qsa('.variant-input-wrap').forEach(group => {
    const nameAttr   = group.getAttribute('name')
    const handleAttr = group.getAttribute('data-handle')
    const optionName = nameAttr || handleAttr || group.dataset.index
    const input = group.querySelector('input[type="radio"]:checked')

    if (optionName && input) {
      selections[optionName] = input.value
    }
  })

  return selections
}

function findVariantForOptions(optionValues) {
  if (!productData || !Array.isArray(productData.variants)) return null

  const groups = qsa('.variant-input-wrap')

  const variant = productData.variants.find(variant => {
    const title = variant.public_title || ''
    const parts = title.split(' / ')

    return groups.every((group, index) => {
      const nameAttr   = group.getAttribute('name')
      const handleAttr = group.getAttribute('data-handle')
      const optionName = nameAttr || handleAttr || group.dataset.index
      const wanted = optionValues[optionName]

      if (wanted == null) return true

      const part = parts[index]
      return String(part) === String(wanted)
    })
  }) || null

  return variant
}

function getPriceForSizeValue(sizeValue) {
  if (!productData) return 0

  const currentSel = getCurrentSelections()
  currentSel['Size'] = sizeValue

  const variant = findVariantForOptions(currentSel)
  if (!variant) return 0

  return variant.price / 100
}

/* ===== Utilities ===== */
const shopCurrency = localStorage.getItem("currency") || '$';
const qs  = (sel, root = document) => root.querySelector(sel);
const qsa = (sel, root = document) => Array.from(root.querySelectorAll(sel));

/* Currency Formatter */
function formatCurrency(value, currency = shopCurrency) {
  const n = typeof value === 'string' ? parseFloat(value) : value;
  if (Number.isNaN(n)) return `${currency}${value}`;
  return Number.isInteger(n) ? `${currency}${n}` : `${currency}${n.toFixed(2)}`;
}

/* ===== State / caches that can be used across functions ===== */
let previousPrice = (qs('.product__price span') || qs('.product__price'))?.textContent || '';
let swiperInstances = [];

/* =========================
   INIT (runs after load)
   ========================= */
window.addEventListener("load", () => {
  /* Feature-gate by DOM existence so old products don’t error */

  // “Number of subjects widget (app)
  if (qs('.cl-po--quantity-wrap.cl-po--number-steps')) {
    subjectQuantityBlock();
  }

  // Size price tags / active size label
  if (qs('.variant-input-wrap[name="Size"] input')) {
    countPriceSizes();
    changeSize();
  }

  // Quantity block (subtotal/discount interactions)
  if (qs('.product__quantity')) {
    changeDiscount();
    changeQuantity();
  }

  // Mount subjects-price badge if the app's option exists (Subjects or Pets)
  const subjectsOrPets = qs(
    '.cl-po--option[data-option="Number of Subjects"], .cl-po--option[data-option="Number of Pets"]'
  );

  if (subjectsOrPets) {
    let badge = subjectsOrPets.querySelector('.subjects-price');

    if (!badge) {
      badge = document.createElement('div');
      badge.classList.add('subjects-price');
      subjectsOrPets.appendChild(badge);
    }
  }

  // App checkboxes hook (if the app exists)
  qsa('.cl-po--checkbox-item input').forEach(input => {
    input.addEventListener('change', () => {
      setTimeout(() => changeQuantityLogic(), 0);
    });
  });

  // Form submit hook (if form exists)
  const productForm = qs(".product-single__form");
  if (productForm) {
    productForm.addEventListener('submit', () => {
      setTimeout(() => changeQuantityLogic(), 0);
    });
  }

  // Seed subtotal once (if subtotal block exists)
  const productSubtotal = qs('.product__subtotal--text span');
  const activePriceEl   = qs('.custom__price.active');
  if (productSubtotal && activePriceEl && activePriceEl.dataset.compare) {
    const compare = parseFloat(activePriceEl.dataset.compare);
    if (!Number.isNaN(compare)) {
      productSubtotal.textContent = formatCurrency(compare);
    }
  }

  // Init mobile swipers for variant rows (if Swiper is present)
  initVariantSwipers();
});

/* Also re-init swipers on resize (throttled) */
let resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(initVariantSwipers, 250);
});

/* When clicking custom variant tiles, run related updates (if present) */
qsa('.custom-variant-button').forEach(item => {
  item.addEventListener("click", () => {
    const customeVariantMessage = qs('.custome-variant__message');
    if (customeVariantMessage) customeVariantMessage.classList.remove("is-show");

    if (qs('.variant-input-wrap[name="Size"] input')) {
      countPriceSizes();
      changeSize();
    }

    setTimeout(() => changeQuantityLogic(), 0);

    // Sync your .custom__price “active” card with URL ?variant
    setTimeout(() => {
      const url = window.location.href;
      const match = url.match(/[?&]variant=(\d+)/);
      const customPrices = qsa('.custom__price');
      if (match) {
        let variantNumber = match[1];
        removeActive(customPrices);
        customPrices.forEach(price => {
          if (String(price.dataset.variant) === String(variantNumber)) {
            price.classList.add("active");
          }
        });
      }
    }, 0);
  });
});

/* =========================
   FUNCTIONS
   ========================= */

function isPetOrMemorialProduct() {
  const id = getProductIdReliable();
  return id === '8996478222652' || id === '9916567486780';
}

function subjectQuantityBlock() {
  const numberSubjects  = qs('.cl-po--quantity-wrap.cl-po--number-steps');
  if (!numberSubjects) return;

  const subjectQuantity = numberSubjects.querySelector('.cl-po--input.cl-po--quantity');
  const subjectButtons  = numberSubjects.querySelectorAll('.cl-po--quantity-btn');
  if (!subjectQuantity || !subjectButtons.length) return;

  subjectButtons.forEach(button => {
    button.addEventListener("click", () => {
      disabledSize(subjectQuantity);
      countPriceSizes();
      countSubjectPrice(subjectQuantity)
    });
  });
}

function disabledSize(subjectQuantity) {
  const selectedSize = qs('.variant-input-wrap[name="Size"] input:checked');
  const allSizes     = qsa('.variant-input-wrap[name="Size"] input');
  let   msg          = qs('.custome-variant__message');

  if (!subjectQuantity || !selectedSize || !allSizes.length || !msg) return;

  let foundSelected = false;
  const [ , maxSelect = 1 ] = (selectedSize.dataset.number || '1').split('-').map(Number);

  allSizes.forEach((item, index) => {
    const [ , max = 1 ] = (item.dataset.number || '1').split('-').map(Number);

    if (Number(subjectQuantity.value) <= max) {
      item.parentElement.classList.remove("disabled");
    } else if (foundSelected === false) {
      item.parentElement.classList.add("disabled");
    }

    const currentSize = msg.querySelector(".size");
    if (currentSize && item.value == currentSize.innerHTML && !item.parentElement.classList.contains("disabled")) {
      msg.classList.remove("is-show");
    }

    if (Number(subjectQuantity.value) > maxSelect && item === selectedSize) {
      const next = allSizes[index + 1];
      if (next) {
        next.click();
        msg.classList.add("is-show");
        const numberEl = msg.querySelector(".number");
        if (currentSize) currentSize.innerHTML = item.value;
        if (numberEl) numberEl.innerHTML = max;
        foundSelected = true;
        changeSize();
      }
    }
  });
}

function countPriceSizes() {
  const allSizes = qsa('.variant-input-wrap[name="Size"] input')
  const selected = qs('.variant-input-wrap[name="Size"] input:checked')
  if (!allSizes.length || !selected) return

  const sizesArray = Array.from(allSizes)

  const sizesAfterChecked = sizesArray.reduce((acc, input, index, array) => {
    const wrapper = input.parentElement?.querySelector('.price_tag')
    if (wrapper) {
      wrapper.classList.remove('is-show')
      wrapper.textContent = ''
    }
    if (input.checked) acc.push(...array.slice(index + 1))
    return acc
  }, [])

  const basePrice = getPriceForSizeValue(selected.value)

  sizesAfterChecked.forEach(input => {
    const wrapper = input.parentElement?.querySelector('.price_tag')
    if (!wrapper) return

    const upPrice = getPriceForSizeValue(input.value)
    const diff = upPrice - basePrice

    if (diff > 0) {
      wrapper.classList.add('is-show')
      wrapper.textContent = `+ ${formatCurrency(diff)}`
    } else {
      wrapper.classList.remove('is-show')
      wrapper.textContent = ''
    }
  })
}

function changeSize() {
  const selected = qs('.variant-input-wrap[name="Size"] input:checked');
  const target   = qs('.size_value_active');
  if (selected && target) target.innerHTML = selected.value;
}

function getProductIdFromDataLayer() {
  if (!Array.isArray(window.dataLayer)) return null;

  for (let i = window.dataLayer.length - 1; i >= 0; i--) {
    const item = window.dataLayer[i];

    const pid =
      item?.ecommerce?.detail?.products?.[0]?.product_id ??
      item?.ecommerce?.items?.[0]?.item_id;

    if (pid !== undefined && pid !== null) {
      const num = Number(pid);
      return Number.isFinite(num) ? num : String(pid);
    }
  }

  return null;
}

function getProductIdReliable() {
  if (productData && productData.id) return String(productData.id);
  const dl = getProductIdFromDataLayer();
  return dl == null ? null : (String(dl).match(/\d+/)?.[0] || String(dl));
}

function countSubjectPrice(subjectQuantity) {
  const numberSubjectsCount = qs('.subjects-price');
  if (!numberSubjectsCount || !subjectQuantity) return;

  const defaultPrices = {
    3: 15, 4: 30, 5: 45, 6: 60, 7: 75, 8: 90, 9: 105, 10: 120
  };

  const petOrMemorialPrices = {
    2: 15, 3: 30, 4: 45, 5: 60, 6: 75, 7: 90, 8: 105, 9: 120, 10: 135
  };

  const productId = getProductIdReliable();

  const petOrMemorialProductIds = new Set([
    '8996478222652',
    '9916567486780'
  ]);

  const isPetOrMemorial =
    productId != null &&
    petOrMemorialProductIds.has(String(productId));

  const addPrices = isPetOrMemorial
    ? petOrMemorialPrices
    : defaultPrices;

  const qty = Number(subjectQuantity.value);
  const extra = addPrices[qty] || 0;

  numberSubjectsCount.textContent =
    extra > 0 ? `+ ${formatCurrency(extra)}` : '';
}

/* Watch price changes (theme updates .product__price) and recalc discount/subtotal */
setInterval(() => {
  const priceEl = qs('.product__price span') || qs('.product__price');
  if (!priceEl) return;
  const currentPrice = priceEl.textContent;
  if (currentPrice !== previousPrice) {
    changeDiscount();
    previousPrice = currentPrice;
  }
}, 500);

function changeDiscount() {
  const qtyEl           = qs('.product__quantity .js-qty__num');
  const subtotalEl      = qs('.product__subtotal--text span');
  const activePriceWrap = qs('.custom__price.active');
  const priceEl         = qs('.product__price span') || qs('.product__price');

  if (!subtotalEl || !activePriceWrap || !priceEl) return;

  const qty = qtyEl ? Number(qtyEl.value || 1) : 1;
  const baseCompare = parseFloat(activePriceWrap.dataset.compare || '0');
  const priceUnit   = parseFloat((priceEl.dataset && priceEl.dataset.price) || baseCompare || '0');

  if (Number.isNaN(baseCompare)) return;

  let total;
  if (qty === 2) {
    total = (baseCompare * qty) + (priceUnit * 0.15);
  } else if (qty === 3) {
    total = (baseCompare * qty) + (priceUnit * 0.20);
  } else {
    total = baseCompare * qty;
  }
  subtotalEl.textContent = formatCurrency(total);
}

function changeQuantity() {
  const plus  = qs('.product__quantity .js-qty__adjust.js-qty__adjust--plus');
  const minus = qs('.product__quantity .js-qty__adjust.js-qty__adjust--minus');
  if (!plus || !minus) return;

  plus.addEventListener('click', () => { changeQuantityLogic(); changeDiscount(); });
  minus.addEventListener('click', () => { changeQuantityLogic(); changeDiscount(); });
}

function changeQuantityLogic() {
  const qtyEl      = qs('.product__quantity .js-qty__num');
  const priceWrap  = qs('.product__price[data-live-format]');
  const priceEl    = qs('.product__price span') || qs('.product__price');

  if (!qtyEl || !priceWrap || !priceEl) return;

  const qty        = Number(qtyEl.value || 1);
  const unitString = priceWrap.dataset.liveFormat || '';
  const unitNumber = parseFloat(unitString.replace('$', '').replace(',', ''));

  if (Number.isNaN(unitNumber)) return;

  priceEl.dataset.price = String(unitNumber * qty);

  let subTotal = unitNumber * qty;
  if (qty === 2) {
    priceEl.textContent = formatCurrency(subTotal - (subTotal * 0.15));
  } else if (qty === 3) {
    priceEl.textContent = formatCurrency(subTotal - (subTotal * 0.20));
  } else {
    priceEl.textContent = formatCurrency(subTotal);
  }
}

function removeActive(array) {
  array.forEach(item => item.classList.remove("active"));
}

/* ===== Mobile-only Swiper for variant rows (safe if Swiper not present) ===== */
function initVariantSwipers() {
  // Destroy existing
  swiperInstances.forEach(sw => {
    try { sw.destroy(true, true); } catch(e) {}
  });
  swiperInstances = [];

  const swiperBlocks = qsa('.swiper-variant');
  if (!swiperBlocks.length) return;
  if (typeof window.Swiper !== 'function') return;

  swiperBlocks.forEach((block) => {
    if (window.innerWidth > 768) return;

    const swiper = new Swiper(block, {
      slidesPerView: 3.5,
      spaceBetween: 10,
      speed: 400,
      on: {
        init: function () {
          const slides = block.querySelectorAll('.swiper-slide');
          let activeIndex = 0;
          slides.forEach((slide, i) => {
            const input = slide.querySelector('input[type="radio"], input[type="checkbox"]');
            if (input && input.checked) activeIndex = i;
          });
          this.slideTo(activeIndex, 0);
        },
      },
    });

    swiperInstances.push(swiper);

    const slides = block.querySelectorAll('.swiper-slide');
    slides.forEach((slide, i) => {
      slide.addEventListener('click', () => {
        try { swiper.slideTo(i, 500); } catch(e) {}
      });
    });
  });
}

/* =========================
   DEPENDENT SWATCH IMAGES (Option A) — FINAL VERSION
   ========================= */

/** ====== CONFIG ====== **/
const SWATCH_CDN_PREFIX = 'https://cdn.shopify.com/s/files/1/0792/4354/2844/files/';
const SWATCH_EXT = '.jpg';

/* Show framing as buttons (no images) */
const FRAMING_BUTTON_MODE = true;

/* Color tiles update based on selected framing */
const UPDATE_COLOR_TILES = true;

/** ====== HELPERS ====== **/
function slugify(str) {
  return String(str || '')
    .toLowerCase()
    .trim()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');
}

function getGroupByHandleContains(fragment) {
  return document.querySelector(`.variant-input-wrap[data-handle*="${fragment}"]`);
}

function getGroupByExactHandle(handle) {
  return document.querySelector(`.variant-input-wrap[data-handle="${handle}"]`);
}

function getSelectedValueFromGroup(groupEl) {
  const input = groupEl && groupEl.querySelector('input[type="radio"]:checked');
  return input ? input.value : null;
}

function getTilesFromGroup(groupEl) {
  return groupEl ? Array.from(groupEl.querySelectorAll('.variant-input')) : [];
}

function preload(urls = []) {
  urls.forEach(u => { const i = new Image(); i.src = u; });
}

/* create a temporary overlay, fade it in, then commit url to target bg */
function crossfadeBackground(targetEl, newUrl) {
  if (!targetEl || !newUrl) return

  // current bg becomes base
  const layer = document.createElement('span')
  layer.className = 'si-fade-layer'
  layer.style.backgroundImage = `url("${newUrl}")`
  targetEl.appendChild(layer)

  // start fade
  requestAnimationFrame(() => layer.classList.add('is-in'))

  // after fade completes, set final bg and cleanup
  const done = () => {
    targetEl.style.backgroundImage = `url("${newUrl}")`
    layer.removeEventListener('transitionend', done)
    layer.remove()
  }
  layer.addEventListener('transitionend', done)
}

/** ====== CORE PAINTERS ====== **/

// Paint COLOR tiles based on selected FRAMING
// Files must be named: color-<color>__<framing>.jpg
function paintColorTilesFromFraming() {
  if (!UPDATE_COLOR_TILES) return;

  const colorGroup = getGroupByHandleContains('color'); // matches "background-color"
  const framingGroup = getGroupByExactHandle('framing');
  if (!colorGroup || !framingGroup) return;

  const selectedFraming = getSelectedValueFromGroup(framingGroup);
  if (!selectedFraming) return;

  const framingSlug = slugify(selectedFraming);
  const tiles = getTilesFromGroup(colorGroup);
  const urls = [];

  tiles.forEach(tile => {
    const colorVal = tile.getAttribute('data-value');
    const colorSlug = slugify(colorVal);
    const url = `${SWATCH_CDN_PREFIX}color-${colorSlug}__${framingSlug}${SWATCH_EXT}`;

    // paint only the chip area
    const chip = tile.querySelector('.color__block');
    if (chip) {
      crossfadeBackground(chip, url);
      chip.style.backgroundSize = 'cover';
      chip.style.backgroundPosition = 'center';
      chip.style.backgroundRepeat = 'no-repeat';
    }
    urls.push(url);
  });

  preload(urls);
}

// Paint FRAMING tiles based on selected COLOR (if not in button mode)
// Files: framing-<framing>__<color>.jpg
function paintFramingTilesFromColor() {
  if (FRAMING_BUTTON_MODE) return; // skip thumbnails for framing

  const colorGroup = getGroupByHandleContains('color');
  const framingGroup = getGroupByExactHandle('framing');
  if (!colorGroup || !framingGroup) return;

  const selectedColor = getSelectedValueFromGroup(colorGroup);
  if (!selectedColor) return;

  const colorSlug = slugify(selectedColor);
  const tiles = getTilesFromGroup(framingGroup);
  const urls = [];

  tiles.forEach(tile => {
    const framingVal = tile.getAttribute('data-value');
    const framingSlug = slugify(framingVal);
    const url = `${SWATCH_CDN_PREFIX}framing-${framingSlug}__${colorSlug}${SWATCH_EXT}`;
    const label = tile.querySelector('.variant__button-label');
    if (label) {
      crossfadeBackground(label, url);
      label.style.backgroundSize = 'cover';
      label.style.backgroundPosition = 'center';
      label.style.backgroundRepeat = 'no-repeat';
    }
    urls.push(url);
  });

  preload(urls);
}

/** ====== CLEANUP FOR BUTTON MODE ====== **/
function normalizeFramingAsButtons() {
  if (!FRAMING_BUTTON_MODE) return;

  const framingGroup = getGroupByExactHandle('framing');
  if (!framingGroup) return;

  getTilesFromGroup(framingGroup).forEach(tile => {
    const label = tile.querySelector('.variant__button-label');
    if (!label) return;

    // Remove any image or caption styles
    label.style.removeProperty('background-image');
    label.style.removeProperty('background-size');
    label.style.removeProperty('background-position');
    label.style.removeProperty('background-repeat');
    label.classList.remove('swatch-as-thumb');
    label.style.removeProperty('color');
    label.style.removeProperty('text-indent');

    // Remove caption if injected earlier
    const cap = tile.querySelector('.swatch-caption');
    if (cap) cap.remove();
  });
}

/** ====== ORCHESTRATION ====== **/
function paintAllDependentSwatches() {
  paintFramingTilesFromColor();   // no-op in button mode
  paintColorTilesFromFraming();   // update color chips
  normalizeFramingAsButtons();    // enforce button-only framing
}

/** ====== EVENTS ====== **/
window.addEventListener('load', paintAllDependentSwatches);

document.addEventListener('click', e => {
  const t = e.target;
  if (t && (t.matches('.variant-input-wrap input') || t.closest('.variant-input-wrap input'))) {
    setTimeout(paintAllDependentSwatches, 0);
  }
});

document.addEventListener('variantChange', () => {
  setTimeout(paintAllDependentSwatches, 0);
});

window.addEventListener('resize', () => {
  setTimeout(paintAllDependentSwatches, 300);
});

const form = document.querySelector('.product-single__form')

form.addEventListener('submit', (evt) =>{

    const btnLoader = form.querySelector(".add-to-cart")

    // btnLoader.classList.add("new-btn--loading");
    btnLoader.classList.add("btn--loading");
    document.querySelector('.uploadkit__popup').classList.remove('show');
    document.querySelector('.uploadkit__popup .overlay').classList.remove('show');

    const productForm = document.querySelector(".product-single__form")

    if(document.querySelector('.uploadkit-upload-field')){
      const uploadkitThumbnails = document.querySelector(".uploadkit-thumbnails")
      const uploadkitButton = document.querySelector(".uploadkit-button")
      const popupButtonOne = document.querySelector(".uploadkit__popup--btn")
      const popupButtonTwo = document.querySelector(".uploadkit__popup--btn-2")

      if(uploadkitThumbnails.innerHTML == ''){
        evt.preventDefault();
        document.querySelector('.uploadkit__popup').classList.add('show');
        document.querySelector('.uploadkit__popup .overlay').classList.add('show');
      } else {
        form.querySelector('.add-to-cart').click()
      }

      popupButtonOne.addEventListener("click", ()=>{
        removePopup()
        uploadkitButton.click()
      })

      popupButtonTwo.addEventListener("click", ()=>{
        removePopup()
        uploadkitThumbnails.innerHTML = " ";
        form.querySelector('.add-to-cart').click()
      })

      document.querySelector('.uploadkit__popup--close').addEventListener('click', ()=>{
        removePopup()
      })

      document.querySelector('.uploadkit__popup .overlay').addEventListener('click', ()=>{
        removePopup()
      })

    } else {
        form.querySelector('.add-to-cart').click()
    }
  
    const removePopup = () => {
      // const btnText = productForm.querySelector("[data-add-to-cart-text]")
      const btnLoader = productForm.querySelector(".add-to-cart")
      btnLoader.classList.remove("new-btn--loading");
      btnLoader.classList.remove("btn--loading");
      document.querySelector('.uploadkit__popup').classList.remove('show');
      document.querySelector('.uploadkit__popup .overlay').classList.remove('show');
    }

  });


function findByText(selector, text) {
  return [...document.querySelectorAll(selector)]
    .find(el => el.textContent.trim().includes(text));
}

  (function() {
  const label = findByText('.variant-wrapper .variant-wrapper__label', 'Framing');
  if (!label) return;

  if (!label.querySelector('.new-badge')) {
    const badge = document.createElement('span');
    badge.className = 'new-badge';
    badge.textContent = 'New arrival';
    badge.style.marginLeft = '8px';
    badge.style.padding = '2px 6px';
    badge.style.background = '#e8f5e9';
    badge.style.color = '#2e7d32';
    badge.style.fontSize = '11px';
    badge.style.fontWeight = '600';
    badge.style.borderRadius = '4px';
    label.appendChild(badge);
  }
})();